import { ISection } from '../../../main';
import { RegistrationPinsQuery } from '../components/registration_pins/queries/registration_pins_query';
import { RegistrationPinsModel } from '../models/registration_pins_model';
import * as _4 from 'lodash4';

export class RegistrationSectionPinsFacade {
  constructor(
    private ngRegistrationPinsModel: RegistrationPinsModel,
    private ngRegistrationPinsQuery: RegistrationPinsQuery
  ) {}

  isSectionSelected(section: ISection) {
    return this.ngRegistrationPinsModel.isSectionSelected(section.id);
  }

  toggleCheck(event: CustomEvent, section: ISection) {
    if (!event.target) {
      return;
    }
    this.ngRegistrationPinsModel.toggleSelection(section, _4.get(event.target, 'checked', false));
    this.ngRegistrationPinsQuery.run();
  }

  onValueChanged(event: CustomEvent, section: ISection) {
    const registerStatusFlags = ['REGISTERED', 'IN_PROGRESS'];
    const sectionPin = {
      section: section,
      pin: event.detail.value
    };
    const sectionIsRegisteredOrInProgress = _4.includes(registerStatusFlags, section.status);
    if (sectionIsRegisteredOrInProgress) {
      this.ngRegistrationPinsModel.updateRegisteredSectionPin(sectionPin);
    } else {
      this.ngRegistrationPinsModel.updateScheduledSectionPin(sectionPin);
    }
  }

  pin(section: ISection) {
    return this.ngRegistrationPinsModel.getPin(section.id);
  }
}

angular.module('capability-ng-scheduler').service('ngRegistrationSectionPinsFacade', RegistrationSectionPinsFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/facades/registration_section_pins_facade.ts